/* eslint-disable */
// source: emailconfig.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.messenger.private.emailconfig.EmailTypes', null, global);
goog.exportSymbol('proto.messenger.private.emailconfig.GetEmailConfigRequest', null, global);
goog.exportSymbol('proto.messenger.private.emailconfig.GetEmailConfigResponse', null, global);
goog.exportSymbol('proto.messenger.private.emailconfig.UpsertEmailConfigRequest', null, global);
goog.exportSymbol('proto.messenger.private.emailconfig.UpsertEmailConfigResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.messenger.private.emailconfig.UpsertEmailConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.messenger.private.emailconfig.UpsertEmailConfigRequest.displayName = 'proto.messenger.private.emailconfig.UpsertEmailConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.messenger.private.emailconfig.UpsertEmailConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.messenger.private.emailconfig.UpsertEmailConfigResponse.displayName = 'proto.messenger.private.emailconfig.UpsertEmailConfigResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.messenger.private.emailconfig.GetEmailConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.messenger.private.emailconfig.GetEmailConfigRequest.displayName = 'proto.messenger.private.emailconfig.GetEmailConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.messenger.private.emailconfig.GetEmailConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.messenger.private.emailconfig.GetEmailConfigResponse.displayName = 'proto.messenger.private.emailconfig.GetEmailConfigResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.messenger.private.emailconfig.UpsertEmailConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    emailType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    cultureCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    subjectLine: jspb.Message.getFieldWithDefault(msg, 4, ""),
    customArea1: jspb.Message.getFieldWithDefault(msg, 5, ""),
    customArea2: jspb.Message.getFieldWithDefault(msg, 6, ""),
    customArea3: jspb.Message.getFieldWithDefault(msg, 7, ""),
    advertisementImageUrl: jspb.Message.getFieldWithDefault(msg, 8, ""),
    sendToCompanyAlertEmail: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
    sendToProductAlertEmail: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    sendToPlanAlertEmail: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    hideAdvertisement: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    advertisementUrl: jspb.Message.getFieldWithDefault(msg, 13, ""),
    overrideAdvert: jspb.Message.getBooleanFieldWithDefault(msg, 14, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.messenger.private.emailconfig.UpsertEmailConfigRequest;
  return proto.messenger.private.emailconfig.UpsertEmailConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {!proto.messenger.private.emailconfig.EmailTypes} */ (reader.readEnum());
      msg.setEmailType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCultureCode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubjectLine(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomArea1(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomArea2(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomArea3(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdvertisementImageUrl(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendToCompanyAlertEmail(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendToProductAlertEmail(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendToPlanAlertEmail(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHideAdvertisement(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdvertisementUrl(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverrideAdvert(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.messenger.private.emailconfig.UpsertEmailConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getEmailType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCultureCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubjectLine();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCustomArea1();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCustomArea2();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCustomArea3();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAdvertisementImageUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSendToCompanyAlertEmail();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getSendToProductAlertEmail();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getSendToPlanAlertEmail();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getHideAdvertisement();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getAdvertisementUrl();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getOverrideAdvert();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional EmailTypes email_type = 2;
 * @return {!proto.messenger.private.emailconfig.EmailTypes}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getEmailType = function() {
  return /** @type {!proto.messenger.private.emailconfig.EmailTypes} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.messenger.private.emailconfig.EmailTypes} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setEmailType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string culture_code = 3;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getCultureCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setCultureCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string subject_line = 4;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getSubjectLine = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setSubjectLine = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string custom_area1 = 5;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getCustomArea1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setCustomArea1 = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string custom_area2 = 6;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getCustomArea2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setCustomArea2 = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string custom_area3 = 7;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getCustomArea3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setCustomArea3 = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string advertisement_image_url = 8;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getAdvertisementImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setAdvertisementImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool send_to_company_alert_email = 9;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getSendToCompanyAlertEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setSendToCompanyAlertEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional bool send_to_product_alert_email = 10;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getSendToProductAlertEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setSendToProductAlertEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool send_to_plan_alert_email = 11;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getSendToPlanAlertEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setSendToPlanAlertEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool hide_advertisement = 12;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getHideAdvertisement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setHideAdvertisement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string advertisement_url = 13;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getAdvertisementUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setAdvertisementUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool override_advert = 14;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.getOverrideAdvert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigRequest.prototype.setOverrideAdvert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.messenger.private.emailconfig.UpsertEmailConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailConfigId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    companyId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    emailType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    cultureCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    subjectLine: jspb.Message.getFieldWithDefault(msg, 5, ""),
    customArea1: jspb.Message.getFieldWithDefault(msg, 6, ""),
    customArea2: jspb.Message.getFieldWithDefault(msg, 7, ""),
    customArea3: jspb.Message.getFieldWithDefault(msg, 8, ""),
    advertisementImageUrl: jspb.Message.getFieldWithDefault(msg, 9, ""),
    sendToCompanyAlertEmail: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    sendToProductAlertEmail: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    sendToPlanAlertEmail: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    hideAdvertisement: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    advertisementUrl: jspb.Message.getFieldWithDefault(msg, 14, ""),
    includeCompanyAdvert: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    companyAdvertisementImageUrl: jspb.Message.getFieldWithDefault(msg, 16, ""),
    companyAdvertisementUrl: jspb.Message.getFieldWithDefault(msg, 17, ""),
    overrideAdvert: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    footerText: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.messenger.private.emailconfig.UpsertEmailConfigResponse;
  return proto.messenger.private.emailconfig.UpsertEmailConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEmailConfigId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 3:
      var value = /** @type {!proto.messenger.private.emailconfig.EmailTypes} */ (reader.readEnum());
      msg.setEmailType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCultureCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubjectLine(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomArea1(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomArea2(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomArea3(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdvertisementImageUrl(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendToCompanyAlertEmail(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendToProductAlertEmail(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendToPlanAlertEmail(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHideAdvertisement(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdvertisementUrl(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeCompanyAdvert(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyAdvertisementImageUrl(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyAdvertisementUrl(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverrideAdvert(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setFooterText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.messenger.private.emailconfig.UpsertEmailConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailConfigId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getEmailType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCultureCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubjectLine();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCustomArea1();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCustomArea2();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCustomArea3();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAdvertisementImageUrl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSendToCompanyAlertEmail();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getSendToProductAlertEmail();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getSendToPlanAlertEmail();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getHideAdvertisement();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getAdvertisementUrl();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIncludeCompanyAdvert();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getCompanyAdvertisementImageUrl();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCompanyAdvertisementUrl();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getOverrideAdvert();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getFooterText();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional int32 email_config_id = 1;
 * @return {number}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getEmailConfigId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setEmailConfigId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 company_id = 2;
 * @return {number}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional EmailTypes email_type = 3;
 * @return {!proto.messenger.private.emailconfig.EmailTypes}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getEmailType = function() {
  return /** @type {!proto.messenger.private.emailconfig.EmailTypes} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.messenger.private.emailconfig.EmailTypes} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setEmailType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string culture_code = 4;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getCultureCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setCultureCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subject_line = 5;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getSubjectLine = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setSubjectLine = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string custom_area1 = 6;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getCustomArea1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setCustomArea1 = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string custom_area2 = 7;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getCustomArea2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setCustomArea2 = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string custom_area3 = 8;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getCustomArea3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setCustomArea3 = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string advertisement_image_url = 9;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getAdvertisementImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setAdvertisementImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool send_to_company_alert_email = 10;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getSendToCompanyAlertEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setSendToCompanyAlertEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool send_to_product_alert_email = 11;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getSendToProductAlertEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setSendToProductAlertEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool send_to_plan_alert_email = 12;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getSendToPlanAlertEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setSendToPlanAlertEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool hide_advertisement = 13;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getHideAdvertisement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setHideAdvertisement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string advertisement_url = 14;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getAdvertisementUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setAdvertisementUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool include_company_advert = 15;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getIncludeCompanyAdvert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setIncludeCompanyAdvert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string company_advertisement_image_url = 16;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getCompanyAdvertisementImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setCompanyAdvertisementImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string company_advertisement_url = 17;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getCompanyAdvertisementUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setCompanyAdvertisementUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional bool override_advert = 18;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getOverrideAdvert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setOverrideAdvert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional string footer_text = 19;
 * @return {string}
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.getFooterText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.UpsertEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.UpsertEmailConfigResponse.prototype.setFooterText = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.messenger.private.emailconfig.GetEmailConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.messenger.private.emailconfig.GetEmailConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    companyName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    emailType: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigRequest}
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.messenger.private.emailconfig.GetEmailConfigRequest;
  return proto.messenger.private.emailconfig.GetEmailConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.messenger.private.emailconfig.GetEmailConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigRequest}
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 3:
      var value = /** @type {!proto.messenger.private.emailconfig.EmailTypes} */ (reader.readEnum());
      msg.setEmailType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.messenger.private.emailconfig.GetEmailConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.messenger.private.emailconfig.GetEmailConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmailType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string company_name = 2;
 * @return {string}
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional EmailTypes email_type = 3;
 * @return {!proto.messenger.private.emailconfig.EmailTypes}
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.prototype.getEmailType = function() {
  return /** @type {!proto.messenger.private.emailconfig.EmailTypes} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.messenger.private.emailconfig.EmailTypes} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigRequest} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigRequest.prototype.setEmailType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.messenger.private.emailconfig.GetEmailConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.messenger.private.emailconfig.GetEmailConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailConfigId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    companyId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    emailType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    cultureCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    subjectLine: jspb.Message.getFieldWithDefault(msg, 5, ""),
    customArea1: jspb.Message.getFieldWithDefault(msg, 6, ""),
    customArea2: jspb.Message.getFieldWithDefault(msg, 7, ""),
    customArea3: jspb.Message.getFieldWithDefault(msg, 8, ""),
    advertisementImageUrl: jspb.Message.getFieldWithDefault(msg, 9, ""),
    sendToCompanyAlertEmail: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    sendToProductAlertEmail: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    sendToPlanAlertEmail: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    hideAdvertisement: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    advertisementUrl: jspb.Message.getFieldWithDefault(msg, 14, ""),
    includeCompanyAdvert: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
    companyAdvertisementImageUrl: jspb.Message.getFieldWithDefault(msg, 16, ""),
    companyAdvertisementUrl: jspb.Message.getFieldWithDefault(msg, 17, ""),
    overrideAdvert: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    footerText: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.messenger.private.emailconfig.GetEmailConfigResponse;
  return proto.messenger.private.emailconfig.GetEmailConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.messenger.private.emailconfig.GetEmailConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEmailConfigId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 3:
      var value = /** @type {!proto.messenger.private.emailconfig.EmailTypes} */ (reader.readEnum());
      msg.setEmailType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCultureCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubjectLine(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomArea1(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomArea2(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustomArea3(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdvertisementImageUrl(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendToCompanyAlertEmail(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendToProductAlertEmail(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSendToPlanAlertEmail(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHideAdvertisement(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdvertisementUrl(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeCompanyAdvert(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyAdvertisementImageUrl(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyAdvertisementUrl(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverrideAdvert(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setFooterText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.messenger.private.emailconfig.GetEmailConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.messenger.private.emailconfig.GetEmailConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailConfigId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getEmailType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCultureCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubjectLine();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCustomArea1();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCustomArea2();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCustomArea3();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAdvertisementImageUrl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSendToCompanyAlertEmail();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getSendToProductAlertEmail();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getSendToPlanAlertEmail();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getHideAdvertisement();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getAdvertisementUrl();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIncludeCompanyAdvert();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getCompanyAdvertisementImageUrl();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCompanyAdvertisementUrl();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getOverrideAdvert();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getFooterText();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional int32 email_config_id = 1;
 * @return {number}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getEmailConfigId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setEmailConfigId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 company_id = 2;
 * @return {number}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional EmailTypes email_type = 3;
 * @return {!proto.messenger.private.emailconfig.EmailTypes}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getEmailType = function() {
  return /** @type {!proto.messenger.private.emailconfig.EmailTypes} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.messenger.private.emailconfig.EmailTypes} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setEmailType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string culture_code = 4;
 * @return {string}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getCultureCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setCultureCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subject_line = 5;
 * @return {string}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getSubjectLine = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setSubjectLine = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string custom_area1 = 6;
 * @return {string}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getCustomArea1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setCustomArea1 = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string custom_area2 = 7;
 * @return {string}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getCustomArea2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setCustomArea2 = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string custom_area3 = 8;
 * @return {string}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getCustomArea3 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setCustomArea3 = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string advertisement_image_url = 9;
 * @return {string}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getAdvertisementImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setAdvertisementImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool send_to_company_alert_email = 10;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getSendToCompanyAlertEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setSendToCompanyAlertEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool send_to_product_alert_email = 11;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getSendToProductAlertEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setSendToProductAlertEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool send_to_plan_alert_email = 12;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getSendToPlanAlertEmail = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setSendToPlanAlertEmail = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool hide_advertisement = 13;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getHideAdvertisement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setHideAdvertisement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional string advertisement_url = 14;
 * @return {string}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getAdvertisementUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setAdvertisementUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool include_company_advert = 15;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getIncludeCompanyAdvert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setIncludeCompanyAdvert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string company_advertisement_image_url = 16;
 * @return {string}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getCompanyAdvertisementImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setCompanyAdvertisementImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string company_advertisement_url = 17;
 * @return {string}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getCompanyAdvertisementUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setCompanyAdvertisementUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional bool override_advert = 18;
 * @return {boolean}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getOverrideAdvert = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setOverrideAdvert = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional string footer_text = 19;
 * @return {string}
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.getFooterText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.messenger.private.emailconfig.GetEmailConfigResponse} returns this
 */
proto.messenger.private.emailconfig.GetEmailConfigResponse.prototype.setFooterText = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * @enum {number}
 */
proto.messenger.private.emailconfig.EmailTypes = {
  UNSPECIFIED: 0,
  PASSWORD_RESET_EMAIL: 1,
  NEW_SUBSCRIPTION: 2,
  INVITATION_EMAIL: 3,
  REFUND_ISSUED: 5,
  SUBSCRIPTION_CANCELLED: 6,
  ONE_TIME_CHARGE: 7,
  ONE_TIME_CREDIT: 9,
  POSITIVE_ONE_TIME_CHARGE: 10,
  SUCCESSFUL_RENEWAL_PAYMENT_EMAIL: 11,
  NEW_TRIAL_SUBSCRIPTION: 12,
  PAYMENT_DETAILS_REQUEST: 13,
  PAYMENT_DECLINED_INITIAL: 14,
  PAYMENT_DECLINED_ATTEMPT_ONE: 15,
  PAYMENT_DECLINED_ATTEMPT_TWO: 16,
  PAYMENT_DECLINED_ATTEMPT_THREE: 17,
  PAYMENT_SUCCEEDED_AFTER_FAILURE: 18,
  PAYMENT_FAILURE_INITIAL: 19,
  INVOICE_LINK: 20,
  NEXT_BILL_ADJUSTMENT: 21,
  CREDIT_NOTE_LINK: 22,
  NEW_CUSTOMER_WITHOUT_SUBSCRIPTION: 23,
  CUSTOMER_PASSCODE: 24,
  REMINDER_72_HOURS_BEFORE_RENEWAL: 25,
  PAYMENT_METHOD_EXPIRING_SOON: 26,
  PAYMENT_METHOD_EXPIRED: 27,
  NEW_PAYMENT_DETAILS_REQUIRED: 28,
  PAUSED_SUBSCRIPTION_RESTARTING_SOON: 29,
  REMINDER_72_HOURS_BEFORE_TRIAL_EXPIRES: 30,
  SUBSCRIPTION_ADDON_CREATED: 32,
  SUBSCRIPTION_ADDON_REMOVED: 33,
  HANDLING_MINIMUM_TERMS_EMAIL: 34,
  TWENTY_DAYS_BEFORE_END_OF_CONTRACT_TERM: 35,
  NEW_ALLOWANCE_APPLIED_TO_EXISTING_SUBSCRIPTION: 36,
  SUBSCRIPTION_ALLOWANCE_REMOVED: 37,
  TOKEN_APPLIED: 38,
  REMINDER_COUPON_EXPIRES_IN_20_DAYS: 39,
  PAYMENT_DECLINED_INITIAL_SCA: 40,
  PAYMENT_DECLINED_ATTEMPT_ONE_SCA: 41,
  PAYMENT_DECLINED_ATTEMPT_TWO_SCA: 42,
  PAYMENT_DECLINED_ATTEMPT_THREE_SCA: 43,
  HANDLING_MINIMUM_TERMS_EMAIL_SCA: 44,
  ONE_TIME_CHARGE_PAYMENT_FAILURE: 45,
  SUBSCRIPTION_BILL_DATE_CHANGED: 46,
  SUCCESSFUL_CSV_DATA_EXPORT: 47,
  PAYMENT_DECLINED_INITIAL_ACH: 48,
  PAYMENT_DECLINED_ATTEMPT_ONE_ACH: 49,
  PAYMENT_DECLINED_ATTEMPT_TWO_ACH: 50,
  PAYMENT_DECLINED_ATTEMPT_THREE_ACH: 51,
  HANDLING_MINIMUM_TERMS_EMAIL_ACH: 52
};

goog.object.extend(exports, proto.messenger.private.emailconfig);
